import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const NorthCarolinaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='north-carolina'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='NC_ZE'
				points='636.44 680.74 659.11 703.9 681.49 699.07 709.01 696.75 723.65 690.56 731.93 675.28 735.33 656.02 749.71 637.75 773.63 619.64 802.06 603.13 828.62 592.66 854.23 587.61 879.1 577.65 886.83 565.46 889.59 549.81 878.24 546.4 866.68 553.13 853.86 558.05 854.95 551.86 861.91 539.53 867.86 523.84 864.59 515.29 866.9 502.15 897.06 507.46 920.39 497.23 934.49 480.58 940.4 469.66 944.53 446.26 934.17 432.68 897.05 426.14 877.36 433.83 857.52 428.74 855.02 420.32 872.06 419.34 884.54 411.17 911.6 402.39 929.38 405.53 927.38 385.24 910.73 357.59 908.84 350.93 757.63 357.7 626.22 358.59 636.44 680.74'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NC_ZE' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NC_ZE')}
			/>
			<polygon
				id='NC_ZW'
				points='626.22 358.59 509.38 359.37 337.58 356.99 325.31 385.92 306.16 404.07 262.09 423.4 244.71 431.5 226.66 428.32 206.24 446.24 182.86 461.26 148.61 479.14 113.32 484.87 98.76 495.06 90.9 508.03 68.38 527.18 61.7 551.52 184.56 555.64 205.52 549.77 225.81 547.76 256.01 534.75 283.03 530.74 341.45 535.46 409.25 547.42 426.35 567.98 428.4 583.49 442.32 585.94 544.93 587.29 636.44 680.74 626.22 358.59'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NC_ZW' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NC_ZW')}
			/>
			<rect
				x='738.14'
				y='484.08'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M737.52,523.6l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M794.66,507.67h-14.69l-2.79,14.75h16.55l-.82,4.26h-21.52l7.69-40.44h20.61l-.83,4.25h-15.6l-2.47,12.95h14.71l-.83,4.22Z'
				className='shape'
			/>
			<rect x='380.15' y='454.1' width='84.31' height='43.33' fill='none' className='shape' />
			<path
				d='M379.54,493.62l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M420.32,496.69l-1.98-40.44h5l.86,24.24c.15,5.23.05,7.99,0,10.53h.14c.94-2.64,1.93-5.26,4.16-10.25l11.2-24.53h5.33l.83,23.28c.19,5.24.18,8.75.09,11.42h.13c1.19-3.48,2.4-6.72,3.95-10.41l10.9-24.28h5.22l-18.76,40.44h-5.27l-1.03-23c-.22-4.7-.17-7,.09-11.63h-.15c-1.35,3.88-2.42,6.97-4.09,10.64l-11.28,24h-5.34Z'
				className='shape'
			/>
			<polygon
				points='643.32 423.06 643.43 427.38 647.97 427.38 643.49 430.06 643.6 434.38 640.73 431.71 636.25 434.38 638.95 430.06 636.07 427.38 640.62 427.38 643.32 423.06'
				className='shape'
			/>
			<rect x='648.79' y='407.09' width='89.18' height='20' fill='none' className='shape' />
			<path
				d='M652.58,408.19c.99-.22,2.33-.35,3.53-.35,1.62,0,3,.38,3.86,1.17.75.65,1.19,1.58,1.19,2.68,0,2.35-1.8,4.1-3.84,4.67v.06c1.13.38,1.66,1.59,1.78,3.25.18,2.25.29,3.8.5,4.45h-2.06c-.09-.34-.26-2.04-.37-3.9-.13-2.23-.94-3.15-2.55-3.15h-1.77l-1.34,7.05h-1.97l3.04-15.94ZM653.16,415.53h1.78c2.52,0,4.15-1.65,4.15-3.59,0-1.73-1.3-2.51-3.13-2.51-.79,0-1.3.07-1.68.17l-1.13,5.92Z'
				className='shape'
			/>
			<path
				d='M672.05,424.13c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM673.34,414.01c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M679.31,424.13l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M695.59,423.46c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM693.39,413.8c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M700.52,424.13l2.22-11.61h1.99l-2.22,11.61h-1.99ZM703.1,409.28c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M708.54,426.77c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM717.46,414.25c-.37-.18-1.09-.4-1.92-.4-2.91,0-4.91,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M723.44,424.13l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<polygon
				points='438.31 538.18 438.41 542.5 442.96 542.5 438.48 545.17 438.59 549.5 435.71 546.83 431.23 549.5 433.93 545.17 431.06 542.5 435.6 542.5 438.31 538.18'
				className='shape'
			/>
			<rect x='443.78' y='522.21' width='111.89' height='20' fill='none' className='shape' />
			<path
				d='M455.71,538.72c-.91.41-2.38.78-4.2.78-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M460.2,539.25l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M483.14,539.25c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM484.43,529.12c-.28-.09-.71-.16-1.38-.16-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M490.44,539.25l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path d='M500.48,539.25l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M519.53,532.2c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM510.61,534.67c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M528.54,524.52l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M538.48,524.52l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M551.49,538.58c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM549.29,528.92c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<polygon
				points='250.99 447.7 251.09 452.02 255.64 452.02 251.16 454.69 251.27 459.02 248.39 456.34 243.91 459.02 246.61 454.69 243.74 452.02 248.28 452.02 250.99 447.7'
				className='shape'
			/>
			<rect x='256.46' y='431.73' width='104.58' height='20' fill='none' className='shape' />
			<path
				d='M260.49,443.65l-2.57,5.12h-2.1l8.36-16.18h2.35l2.24,16.18h-2.04l-.65-5.12h-5.58ZM265.92,442.06l-.63-4.67c-.09-.84-.21-2.03-.29-2.98h-.06c-.43.96-.83,1.97-1.32,2.95l-2.41,4.7h4.71Z'
				className='shape'
			/>
			<path
				d='M273.41,446.75c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M284.69,448.77l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M308.3,448.1c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM306.1,438.44c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M315.88,437.16l1,6.61c.18,1.32.32,2.21.37,2.85h.07c.25-.62.56-1.38,1.24-2.7l3.54-6.76h2.18l-6.46,11.61h-1.96l-2.01-11.61h2.03Z'
				className='shape'
			/>
			<path
				d='M326.64,448.77l2.22-11.61h1.99l-2.22,11.61h-1.99ZM329.22,433.92c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M334.56,448.77l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M342.48,448.77l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M358.77,448.1c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM356.57,438.44c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='609.71 391.79 609.81 396.11 614.36 396.11 609.88 398.78 609.99 403.11 607.11 400.44 602.63 403.11 605.33 398.78 602.46 396.11 607 396.11 609.71 391.79'
				className='shape'
			/>
			<rect x='516.17' y='370.82' width='96.36' height='20' fill='none' className='shape' />
			<path
				d='M519.96,371.9c1.24-.22,2.6-.32,4.02-.32,2.7,0,4.76.77,5.95,2.15.87.9,1.51,2.35,1.52,4.39,0,2.93-1.17,5.83-3.25,7.6-1.87,1.57-4.23,2.25-7.33,2.25-1.41,0-2.87-.08-3.92-.2l3.01-15.87ZM519.24,386.2c.73.1,1.49.11,2.09.11,2.57,0,4.44-.76,5.79-2.15,1.46-1.49,2.21-3.69,2.21-5.97,0-2.86-1.4-5-5.43-5-.72,0-1.63.04-2.21.17l-2.44,12.84Z'
				className='shape'
			/>
			<path
				d='M546.27,376.25l-1.56,8.23c-.25,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.19.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.65-.2,1.2-.2,1.7,0,1.2.49,2.02,1.86,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M550,387.86l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M560.03,387.86l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M582.97,387.86c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM584.26,377.73c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M590.27,387.86l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.75l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.26-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.46-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.84h-1.95Z'
				className='shape'
			/>
			<polygon
				points='449.4 395.18 449.51 399.51 454.06 399.51 449.58 402.18 449.68 406.5 446.81 403.83 442.33 406.5 445.03 402.18 442.15 399.51 446.7 399.51 449.4 395.18'
				className='shape'
			/>
			<rect x='421.14' y='409.32' width='134.53' height='20' fill='none' className='shape' />
			<path
				d='M433.79,425.66c-.94.37-2.66.85-4.56.85-2.28,0-4.06-.65-5.29-2.01-1.23-1.35-1.63-3.12-1.63-4.72,0-2.68,1.09-5.49,3.16-7.36,1.73-1.52,4.06-2.4,6.65-2.4,1.99,0,3.33.45,3.82.74l-.66,1.68c-.82-.42-1.94-.7-3.4-.7-1.9,0-3.66.71-5.01,1.97-1.51,1.41-2.42,3.73-2.42,5.92,0,3.12,1.57,5.19,5.16,5.19.96,0,1.87-.2,2.46-.46l.92-4.83h-3.28l.31-1.63h5.23l-1.46,7.77Z'
				className='shape'
			/>
			<path
				d='M439.22,426.36l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M457.5,425.69c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM455.3,416.03c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M470.82,425.69c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM468.62,416.03c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M475.75,426.36l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M491.08,424.34c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.59,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M507.48,409.31l-1.53,7.54h.05c1.03-1.55,2.52-2.37,4.08-2.37,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-3,0-.57.09-1.25.2-1.8l2.5-12.51h1.99ZM504.96,421.87c-.08.39-.15.86-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.21-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M528.6,419.31c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM519.67,421.78c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M532.41,426.36l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M553.46,419.31c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM544.53,421.78c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='730.82 632.6 730.92 636.93 735.47 636.93 730.99 639.6 731.1 643.92 728.22 641.25 723.74 643.92 726.44 639.6 723.57 636.93 728.11 636.93 730.82 632.6'
				className='shape'
			/>
			<rect x='730.36' y='613.67' width='136.66' height='20' fill='none' className='shape' />
			<path
				d='M733.49,630.71l-.79-16.18h2l.34,9.7c.06,2.09.02,3.2,0,4.21h.06c.38-1.06.77-2.11,1.66-4.1l4.48-9.81h2.13l.33,9.31c.07,2.1.07,3.5.04,4.57h.05c.48-1.39.96-2.69,1.58-4.16l4.36-9.71h2.09l-7.51,16.18h-2.11l-.41-9.2c-.09-1.88-.07-2.8.04-4.65h-.06c-.54,1.55-.97,2.79-1.63,4.26l-4.51,9.6h-2.13Z'
				className='shape'
			/>
			<path
				d='M753.17,630.71l2.22-11.61h1.99l-2.22,11.61h-1.99ZM755.75,615.86c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M761.09,630.71l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M769.01,630.71l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.05c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.29,6.85h-1.95l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M790.82,630.71l2.22-11.61h1.99l-2.22,11.61h-1.99ZM793.41,615.86c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M798.74,630.71l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M814.08,633.35c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM823.01,620.83c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.91,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M834.18,615.98l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M849.96,623.67c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM841.04,626.13c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M853.78,630.71l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
		</svg>
	);
};

NorthCarolinaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default NorthCarolinaMap;
